import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"outlined":"","hide-details":"auto","label":_vm.$t('Searchable weight'),"type":"number"},model:{value:(_vm.searchable),callback:function ($$v) {_vm.searchable=_vm._n($$v)},expression:"searchable"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }